export const useStyles = {
  sectionSpacing: {
    paddingTop: "15px",
    "& p": {
      padding: "0px",
    },
  },
};
